/**
 * What the sign-up form and the free-trial page say about the trial, from the brand's
 * trial package (useTrialOffer: what signing up today actually gets). With the trial
 * package switched off the copy invites a free account and promises no trial.
 */
export interface TrialCopy {
  heading: string;
  subtitle: string;
  button: string;
  badge: string;
}

export function trialCopy(trialDays: number | null): TrialCopy {
  if (!trialDays) {
    return {
      heading: 'Create Your Account',
      subtitle: 'Join in a minute. No credit card needed.',
      button: 'Create Account',
      badge: 'Every race, every track',
    };
  }
  return {
    heading: 'Start Free Trial',
    subtitle: `Get full access for ${trialDays} ${trialDays === 1 ? 'day' : 'days'}, completely free`,
    button: 'Start Free Trial',
    badge: `${trialDays}-Day Free Trial`,
  };
}
